import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = {
  class: "datepicker--calendar-month font-size-14",
  ref: "popupCalendarMonth"
}
const _hoisted_2 = { class: "flex justify-between px-2 items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("a", null, [
  /*#__PURE__*/_createVNode("span", { class: "cp-icon-chevron-left text-2xl" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("a", null, [
  /*#__PURE__*/_createVNode("span", { class: "cp-icon-chevron-right text-2xl" })
], -1)
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = {
  ref: "popupCalendarYear",
  style: {"position":"absolute","top":"54px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")
  const _component_CalendarYear = _resolveComponent("CalendarYear")
  const _directive_click_outside = _resolveDirective("click-outside")

  return _withDirectives((_openBlock(), _createBlock("div", {
    style: { width: _ctx.width + 'px' }
  }, [
    _createVNode("div", {
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
      ref: "calendarMonth",
      class: _ctx.disabled ? 'pointer-events-none' : ''
    }, [
      _createVNode(_component_Input, {
        disabled: _ctx.disabled,
        placeholder: _ctx.placeholder,
        modelValue: _ctx.valueShow,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.valueShow = $event)),
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeInput($event))),
        iconPrepend: "cp-icon-calendar",
        "error-server": _ctx.errorServer,
        required: _ctx.required,
        validated: _ctx.validated,
        errors: _ctx.errorMessage,
        "onUpdate:errors": _cache[3] || (_cache[3] = ($event: any) => (_ctx.errorMessage = $event))
      }, null, 8, ["disabled", "placeholder", "modelValue", "error-server", "required", "validated", "errors"])
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("header", _hoisted_2, [
        _createVNode("span", {
          class: "prev cursor-pointer",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.currentYear--))
        }, [
          _hoisted_3
        ]),
        _createVNode("span", {
          class: "cursor-pointer year-header",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onClickYear && _ctx.onClickYear(...args)))
        }, _toDisplayString(_ctx.currentYear), 1),
        _createVNode("span", {
          class: "next cursor-pointer",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.currentYear++))
        }, [
          _hoisted_4
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.monthLabels, (item, index) => {
          return (_openBlock(), _createBlock("span", {
            onClick: ($event: any) => (_ctx.onSelectMonth(index)),
            class: ["cell month", [
            _ctx.isMonthSelected(index) ? 'selected' : '',
            _ctx.isMonthToday(index) ? 'month-current' : '',
          ]],
            key: item
          }, _toDisplayString(item), 11, ["onClick"]))
        }), 128))
      ])
    ], 512), [
      [_vShow, _ctx.isShowCalendarMonth]
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_CalendarYear, {
        modelValue: _ctx.currentYear,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.currentYear = $event)),
        "is-show-calendar": _ctx.isShowCalendarYear,
        "is-click-year-header": "",
        onOnClickYearHeader: _ctx.closeCalendarYear,
        onSelectYear: _ctx.closeCalendarYear
      }, null, 8, ["modelValue", "is-show-calendar", "onOnClickYearHeader", "onSelectYear"])
    ], 512)
  ], 4)), [
    [_directive_click_outside, _ctx.closeCalendar]
  ])
}